import { Injectable } from '@angular/core';
import {AngularFireFunctions} from '@angular/fire/compat/functions';

@Injectable({
  providedIn: 'root'
})
export class SalesProcessV1Service {

  constructor(private ff: AngularFireFunctions) { }

  async salesProcessV1(data: any) {
    const salesProcessV1 = this.ff.httpsCallable('salesProcessV1');
    return salesProcessV1(data);
  }

}
